import clsx from "clsx";
import { PropsWithChildren } from "react";

import { PreloaderForMccm } from "./index";
import styles from "./index.module.css";

export type FullscreenCoverPreloaderProps = PropsWithChildren & {};

export const FullscreenCoverPreloader = ({ children }: PropsWithChildren<FullscreenCoverPreloaderProps>) => {
  return (
    <main className={styles.fullscreenCoverRoot}>
      {children}
      <PreloaderForMccm className={clsx(styles.cover, "fixed left-0 top-0")} />
    </main>
  );
};
